<template>
  <div class="containerGeneral">
    <div class="contentTable">
      <div class="contentUnicFile">
        <div class="contentInputFile">
          <label
            for="inputFile"
            class="labelInputFile"
            @dragover="handleDragOver"
            @drop="handleDrop($event)"
          >
            <span class="textSelectFile">
              <div
                :class="`contentIconAttachFile ${
                  getNameFile && 'selectedFile'
                }`"
              >
                <b-icon-file-earmark-text style="width: 30px; height: 30px" />
              </div>

              <div v-if="getNameFile">
                <p
                  class="m-0 p-0 textDropFile"
                  :style="getNameFile && 'color: #006256;'"
                >
                  {{ getNameFile }}
                </p>

                <p class="m-0 p-0 subTextDropFile">
                  Arquivo pronto para leitura!
                </p>
              </div>

              <div v-else>
                <p class="m-0 p-0 textDropFile">
                  Clique ou arraste seu arquivo XML
                </p>

                <p class="m-0 p-0 subTextDropFile">
                  Apenas arquivos .xml são suportados
                </p>
              </div>
            </span>
          </label>

          <input
            accept=".xml"
            type="file"
            multiple
            id="inputFile"
            name="inputFile"
            ref="fileInput"
            @change="handleFileChange($event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    disabledInput: {
      type: Boolean,
      default: false,
    },
    isClear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      file: [],
    };
  },
  methods: {
    handleDragOver(event) {
      event.preventDefault();
    },

    handleDrop(event) {
      event.preventDefault();
      this.file = this.handleFiles(event.dataTransfer.files);
    },

    handleFileChange(event) {
      this.file = this.handleFiles(event.target.files);
    },

    handleFiles(listFiles) {
      const files = Object.keys(listFiles).map((key) => {
        return listFiles[key];
      });

      return files;
    },

    clearValues() {
      this.file = [];
    },
  },
  computed: {
    getNameFile() {
      if (this.file.length) {
        return this.file[0].name;
      }

      return null;
    },
  },
  watch: {
    isClear() {
      this.clearValues();
    },
  },
};
</script>

<style scoped>
.containerGeneral {
  padding: 1rem 1rem;
  width: 100%;
  height: 100%;
}

.contentTable {
  width: 100%;
  height: 100%;
}

.contentUnicFile {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.3rem;
}

.btnAddNewFile {
  display: flex;
  align-items: center;
  gap: 3px;
  border-radius: 5px;
  background-color: #006256;
  border: none;
  color: white;
  font-size: 10px;
  border: solid 1px rgba(63, 143, 178, 0.975);
  color: rgba(63, 143, 178, 0.975);
  background-color: whitesmoke;
  padding: 3px 5px;
}

.btnAddNewFile p {
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
}

/* INPUT FILE */

input[type="file"] {
  display: none;
}

.labelInputFile {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 15px;
  cursor: pointer;
  margin: 0;
  height: auto;
  width: 65%;
  background-color: #c1c1c120;
  border: dashed 1px #a7a7a7;
}

.textSelectFile {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 0.9rem;
  margin-bottom: 0;
  border-radius: 5px;
  font-size: 11px;
  padding: 2rem;
}

.textSelectFile p {
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
}

.textDropFile {
  /* max-width: 130px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  font-size: 0.85rem;
  color: rgba(28, 28, 28, 0.764);
  font-weight: 600 !important;
}

.subTextDropFile {
  font-size: 0.7rem;
  color: rgb(111, 111, 111);
  font-weight: 500 !important;
}

.contentInputFile {
  width: 100%;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
}

.contentIconAttachFile {
  width: 55px;
  height: 55px;
  display: flex;
  background-color: #0062562f;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: rgba(50, 74, 51, 0.478);
}

.selectedFile {
  background-color: #00baa436;
  color: #006256;
}

.contentIconRemoveFile {
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 4px;
  color: rgb(255, 51, 51);
}

.contentBtnAdd {
  padding: 0 0 0 1rem;
}

@media screen and (max-width: 991px) {
  .contentTable {
    overflow-x: auto;
  }

  .containerGeneral {
    width: 100%;
  }

  .contentBtnAdd {
    margin-top: 1rem;
  }
}
</style>